import * as React from 'react';

export const useFileDrop = (onUpload) => {
  const ref = React.useRef(null);
  const [drag, setDrag] = React.useState(false);

  const onDragOver = (val) => (e) => {
    e.preventDefault();
    setDrag(val);
  };

  const onDrop = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      onUpload(e.dataTransfer.files[0]);
    }
    setDrag(false);
  };

  const onChange = (e) => {
    const files = e.target.files;
    if (files.length > 0) {
      onUpload(files[0]);
    }
  };

  const onClick = () => {
    ref.current.click();
  };

  const HiddenInput = () => (
    <input
      type="file"
      accept="image/*"
      style={{ display: 'none' }}
      onChange={onChange}
      ref={ref}
    />
  );

  const DropBox = (props) => (
    <div
      onDragEnter={onDragOver(true)}
      onDragLeave={onDragOver(false)}
      onDragOver={onDragOver(true)}
      onDrop={onDrop}
      {...props}
    >
      {props.children}
    </div>
  );

  return {
    DropBox,
    HiddenInput,
    onClick,
    drag,
  };
};
